export default __webpack_public_path__ + "media/images/delete2_v2-d1973035badd6c94fd0a375c04fa6d46.png";